



function inputMaterialDesign() {


    if( jQuery(".inputctn-t.toplbl-m7").length ){
        console.log("inputttttt")

        var mainInput                   = ".inputctn-t";
        var handlerInput                = ".toplbl-m7";
        var activeInputLabel            = "active-m7";
        var activedInput                = ".inputctn-t.active-m7";
        // var selectedInput               = ".inputs-t";
        var selectedInput               = ".inputctn-t input";


        jQuery(selectedInput).click(function(e) {
            jQuery(this).parents(mainInput).addClass(activeInputLabel);
        })

        var inputActivator = function(){
            jQuery(handlerInput).removeClass(activeInputLabel);
        }

        jQuery(document).mouseup(function (e){
        
            var container = jQuery(activedInput); // Give you class or ID

            if (!container.is(e.target) &&            // If the target of the click is not the desired div or section
                container.has(e.target).length === 0) // ... nor a descendant-child of the container
            {
                inputActivator(e);
            }
        });
    }
};





export {inputMaterialDesign}
